<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="店铺权限" name="authorization"></el-tab-pane>
        <el-tab-pane label="下载公告" name="storePlanConfig"></el-tab-pane>
      </el-tabs>
      <component :is="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin';
import authorization from '../authorization/authorization';
import storePlanConfig from '../storePlanConfig/storePlanConfig';

export default {
  components: { authorization, storePlanConfig },
  mixins: [pagePathMixin],
  data() {
    return {
      activeName: null,
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    this.activeName = 'authorization';
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
</style>